// removed by extract-text-webpack-plugin
module.exports = {"editCategoryButton":"edit-category-button--whx2b","editCategoryText":"edit-category-text--lN8at","createIssueButton":"create-issue-button--1eYpL","createIssueText":"create-issue-text--t2kxO","categoryHeading":"category-heading--28uJt","issueTypesTableWrapper":"issue-types-table-wrapper--1f1fM","categoryDetailsWrapper":"category-details-wrapper--2t5jL"};


//////////////////
// WEBPACK FOOTER
// ./app/components/containers/ticketing/categorySettings/categoryDetails/categoryDetails.scss
// module id = fG+o
// module chunks = 1